import { lazy } from 'react';

/** Открывает библиотеку шаблонов промобаннеров */
export const PromotionBannerTemplatesPageAsync = lazy(() => import('./PromotionBannerTemplatesPage'));
